<div class="d-lg-flex">
    <div class="d-flex flex-wrap justify-content-center gap-2 align-items-center mt-3 w-100">
        <button mat-raised-button color="primary" (click)="getNextPage(-10)">
            <i class="fas fa-angle-double-left"></i>
        </button>
        <button mat-raised-button color="primary" (click)="getNextPage(-1)">
            <i class="fas fa-angle-left"></i>
        </button>
        <span class="w-25 text-center">
            {{ pageNumber + 1 }} / {{ totalPage }}
        </span>
        <button mat-raised-button color="primary" (click)="getNextPage(1)">
            <i class="fas fa-angle-right"></i>
        </button>
        <button mat-raised-button color="primary" (click)="getNextPage(10)">
            <i class="fas fa-angle-double-right"></i>
        </button>
    </div>
    <div class="d-flex flex-wrap justify-content-center gap-2 align-items-end my-3 w-100">
        <form (ngSubmit)="searchPokemon()" class="d-flex gap-2">
            <mat-form-field class="d-flex flex-column">
                <mat-label>Pokemon</mat-label>
                <input type="text" placeholder="Input pokemon name" aria-label="Pokemon" matInput
                    [formControl]="myControl" [matAutocomplete]="auto" />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <div>
                <button mat-raised-button color="primary" type="submit">Search</button>
            </div>
        </form>
    </div>
</div>
<div class="d-flex flex-wrap justify-content-center">
    <app-pokemon-card *ngFor="let pokemon of pokemons" pokemonName="{{ pokemon.name }}" pokemonUrl="{{ pokemon.img }}">
    </app-pokemon-card>
</div>